import { EntityAboutCard } from '../EntityAboutCard/EntityAboutCard';
import { useEntity } from '@backstage/plugin-catalog-react';
import { Region } from '@internal/plugin-pulse-common';

export function RegionAboutCard() {
  const { entity } = useEntity();
  const spec = (entity?.spec as Region) ?? {};

  const fields = {
    Description: spec.description,
  };

  return <EntityAboutCard fields={fields} />;
}
